import { render, staticRenderFns } from "./CategoriesGroupsList.vue?vue&type=template&id=79e954e6&scoped=true&"
import script from "./CategoriesGroupsList.vue?vue&type=script&lang=js&"
export * from "./CategoriesGroupsList.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesGroupsList.vue?vue&type=style&index=0&id=79e954e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e954e6",
  null
  
)

export default component.exports